<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Tipo de movimento</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    v-model="movimento.tipo_movimentacao.nome"
                  />
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <ckeditor
                    :editor="editor"
                    v-model="movimento.descricao"
                    :config="editorConfig"
                    disabled
                  ></ckeditor>
                </div>
                <div class="col-md-3 mt-3 mb-3">
                  <label>Nota Fiscal</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="movimento.nota_fiscal || 'Não informado'"
                  />
                </div>
                <div class="col-md-3 mt-3 mb-3">
                  <label>Data da Nota Fiscal</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="movimento.data_nota_fiscal || 'Não informado'"
                  />
                </div>
                <div class="col-md-3 mt-3 mb-3">
                  <label>Número de Empenho</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="movimento.numero_empenho || 'Não informado'"
                  />
                </div>
                <div class="col-md-3 mt-3 mb-3">
                  <label>Rede FES</label>
                  <input
                    type="text"
                    class="form-control"
                    disabled
                    :value="
                      movimento.rede_fes === 1
                        ? 'Sim'
                        : movimento.rede_fes === 0
                        ? 'Não'
                        : 'Não informado'
                    "
                  />
                </div>
              </div>
              <div class="col-md-12 row p-0 m-0">
                <hr />
                <div class="col-md-6 mt-1">Material</div>
                <div class="col-md-2 mt-1">Lote</div>
                <div class="col-md-2 mt-1">Validade</div>
                <div class="col-md-2 mt-1">Quantidade</div>
              </div>
              <div
                class="col-md-12 row p-0 m-0"
                id="lotes"
                v-for="material in materiais"
                :key="material.id"
              >
                <div class="col-md-6 mt-1">{{ material.material }}</div>
                <div class="col-md-2 mt-1">{{ material.lote }}</div>
                <div class="col-md-2 mt-1">{{ material.validade }}</div>
                <div class="col-md-2 mt-1">{{ material.quantidade }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      movimento: {},
      materiais: [],
      tipo_movimentos: [],
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {},
  methods: {
    getMovimento: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "movimentos/" +
        id +
        "?&with[]=tipo_movimentacao";

      axios
        .get(api)
        .then((response) => {
          self.movimento = response.data.data[0];
          self.movimento.tipo_movimentacao.nome
            ? self.movimento.tipo_movimentacao.nome
            : "Não informado";
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "movimentos_materiais?movimento_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getMovimento(id);
      self.getMateriais(id);
    }
  },
  components: {
    BaseCrud,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>